import { Box, Button , Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import DropDownOA from '../../../common/dropDownOA'
import { navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { FilterInput } from '../../../common/filterInput'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { dataDummybranchWiseRate } from './dummyConstans'
import { branchWiseRateHead } from './rateMatrixConstants'
import { useTranslation } from '../../../../i18n/I18nProvider'

const ViewBranchWiseKgkm = (props) => {
  const { data } = props
  const theme = useTheme()
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const t = (key, fallback) => gs?.[key] || fallback
  const translatedBranchWiseRateHead = branchWiseRateHead.map((col) => ({ ...col, headerName: t(col.translationKey, col.headerName) }))
  const { common } = data
  const { loginData } = common

  const [serviceTypeList, setServiceTypeList] = useState([])

  const loadServiceType = () => {
    setServiceTypeList(dataDummybranchWiseRate)
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0' }}>
        <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA label={t('selectSourceCity', 'Select Source City')} idKey={`id`} dataKey={`name`} minWidth="230px" nextId={``} prevId={``} />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA label={t('selectSourceBranch', 'Select Source Branch')} idKey={`id`} dataKey={`name`} minWidth="230px" nextId={``} prevId={``} />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => {})}
              id={'search_btn'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => loadServiceType()}
            >
              {t('load', 'Load')}
            </Button>
          </Item>
        </Box>
      </Box>
      <TableContainer component={Paper} style={{ marginBottom: '5px', width: 'fit-content' }}>
        {serviceTypeList.length > 0 && (
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '&.MuiTableCell-root': {
                padding: '6px 8px!important',
              },
              width: 'unset',
            }}
          >
            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
              <TableRow>
                {translatedBranchWiseRateHead.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      backgroundColor: '#DAEDFE',
                      minHeight: '40px',
                      fontSize: '12px',
                      fontWeight: '700',
                      color: '#444',
                      height: '36px',
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {translatedBranchWiseRateHead.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    sx={{
                      ...col.headerSx,
                      minHeight: '40px',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444',
                      height: '36px',
                      fontSize: '12px',
                    }}
                  >
                    <FilterInput />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {serviceTypeList.length > 0 && (
              <TableBody>
                {serviceTypeList.map((item, index) => (
                  <TableRow key={index}>
                    {translatedBranchWiseRateHead.map((col, i) => (
                      <TableCell
                        key={`Tsd-${index + i}`}
                        sx={{ ...col.headerSx, height: '36px', fontSize: '12px', background: item.isCity ? '#F2F9FF' : '#fff' }}
                      >
                        {item[col.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        )}
      </TableContainer>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(ViewBranchWiseKgkm)
